// ============================================================
// Role Access API — Super Admin Role-based Module & Menu Access
// ============================================================

import client from '../client';

export const roleAccessApi = {
  // GET /schools/{school_id}/roles — Fetch available roles for a school
  getSchoolRoles: async (schoolId) => {
    const response = await client.get(`/schools/${schoolId}/roles`);
    return response.data;
  },

  // GET /schools/{school_id}/roles/{role_id}/access — Fetch modules & menus access tree for a role
  getRoleAccess: async (schoolId, roleId) => {
    const response = await client.get(`/schools/${schoolId}/roles/${roleId}/access`);
    return response.data;
  },

  // PUT /schools/{school_id}/roles/{role_id}/access — Save updated module & menu access for a role
  updateRoleAccess: async (schoolId, roleId, modulesPayload) => {
    const response = await client.put(`/schools/${schoolId}/roles/${roleId}/access`, {
      modules: modulesPayload,
    });
    return response.data;
  },
};
